import { render, staticRenderFns } from "./CompetenceCompareLocals.vue?vue&type=template&id=4bed864a&scoped=true"
import script from "./CompetenceCompareLocals.vue?vue&type=script&lang=js"
export * from "./CompetenceCompareLocals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed864a",
  null
  
)

export default component.exports